module.exports = __webpack_public_path__ + "media/images/main_search-e23d4de802188ad7755613afa9c6f0ad.png";